import React from "react";
import { HiCheckCircle } from "react-icons/hi";
import LoyaltyCardContainer from "../LoyaltyCardContainer";
import BusinessCardFooter from "../BusinessCardFooter";

interface ErrorViewProps {
  t: (key: string, options?: Record<string, unknown>) => string;
}

const ERROR_GRADIENT_CLASS = "bg-gradient-to-br from-blue-400 to-blue-600";

const ErrorView: React.FC<ErrorViewProps> = ({ t }) => {
  const errorContent = (
    <div className="w-full h-full" translate="no">
      <div className="w-full h-full min-h-0 relative rounded-xl overflow-hidden">
        <div className="row-start-1 row-end-2 min-h-0">
          <div
            className="h-full overflow-y-auto overscroll-contain touch-pan-y"
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            <div className="rounded-xl overflow-hidden shadow-lg border border-white/20 backdrop-blur m-3 sm:m-4">
              <div className="relative px-5 pt-5 pb-6 sm:px-6 sm:pt-6 sm:pb-7 flex flex-col">
                <div
                  className={`absolute inset-0 opacity-95 ${ERROR_GRADIENT_CLASS}`}
                />
                <div className="relative z-10 flex items-center gap-3 min-w-0 flex-1">
                  <div className="flex-shrink-0 w-14 h-14 rounded-xl overflow-hidden border-2 border-white/60 shadow-lg bg-white p-2">
                    <img
                      src="https://cdn.1cdn.app/application/UMD/24042216091381_Logo.svg"
                      alt="Super User Manager"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h2 className="text-2xl font-bold text-white leading-tight">
                      {t("key13")}
                    </h2>
                    <p className="text-sm text-white/90 mt-0.5 font-medium">
                      {t("event.errors.poweredBy")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden shadow-lg border border-white/20 backdrop-blur m-3 sm:m-4">
              <div className="relative px-5 pt-8 pb-8 sm:px-6 sm:pt-10 sm:pb-10 flex flex-col">
                <div
                  className={`absolute inset-0 opacity-95 ${ERROR_GRADIENT_CLASS}`}
                />
                <div className="relative z-10 flex flex-col gap-5 items-center justify-center">
                  <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center border-2 border-white/40 shadow-lg">
                    <svg
                      className="w-10 h-10 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </div>
                  <div className="text-center">
                    <h2 className="text-2xl font-bold text-white mb-2">
                      {t("event.errors.title")}
                    </h2>
                    <p className="text-white/90 text-sm leading-relaxed max-w-xs mx-auto">
                      {t("event.errors.message")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden shadow-lg border border-white/20 bg-gray-950/90 backdrop-blur m-3 sm:m-4">
              <div className="relative px-5 pt-6 pb-6 sm:px-6 sm:pt-7 sm:pb-7 flex flex-col">
                <div
                  className={`absolute inset-0 opacity-95 ${ERROR_GRADIENT_CLASS}`}
                />
                <div className="relative z-10 flex flex-col gap-5">
                  <div className="text-center">
                    <h4 className="text-xl font-bold text-white mb-2">
                      {t("event.promo.title")}
                    </h4>
                    <p className="text-sm text-white/90 mb-5 font-medium leading-relaxed">
                      {t("event.promo.subtitle")}
                    </p>
                    <ul className="text-left text-sm text-white/90 space-y-3">
                      <li className="flex items-start gap-3">
                        <HiCheckCircle className="w-5 h-5 text-green-300 flex-shrink-0 mt-0.5" />
                        <span className="font-medium">
                          {t("event.promo.features.unlimited")}
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <HiCheckCircle className="w-5 h-5 text-green-300 flex-shrink-0 mt-0.5" />
                        <span className="font-medium">
                          {t("event.promo.features.tickets")}
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <HiCheckCircle className="w-5 h-5 text-green-300 flex-shrink-0 mt-0.5" />
                        <span className="font-medium">
                          {t("event.promo.features.attendance")}
                        </span>
                      </li>
                      <li className="flex items-start gap-3">
                        <HiCheckCircle className="w-5 h-5 text-green-300 flex-shrink-0 mt-0.5" />
                        <span className="font-medium">
                          {t("event.promo.features.payment")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row-start-3 row-end-4">
          <BusinessCardFooter showFooter={true} theme="default" />
        </div>
      </div>
    </div>
  );

  return (
    <LoyaltyCardContainer
      frontContent={errorContent}
      backContent={errorContent}
      isPreview={false}
      isFlipping={false}
      showEmailLogin={false}
      className="max-w-[360px] w-full"
      fullHeight={true}
    />
  );
};

export default ErrorView;
